export const SUBMIT_LOGIN_INFO = "SUBMIT_LOGIN_INFO";
export const SUBMIT_LOGIN_INFO_SUCCESS = "SUBMIT_LOGIN_INFO_SUCCESS";